import { useState } from 'react';
import { toast } from 'react-toastify';
import { t } from 'i18next';
import { getCountryReport } from '@api/getCountryReport';
import { CountryReportType } from '@type/countryReport';

export type ElectionsType = {
  election_date: string;
  election_name_bn: string;
  election_name_en: string;
  election_schedule_id: number;
  election_type: number;
  is_active: boolean;
};

export const useGetCountryReport = () => {
  const [countryData, setCountryReport] = useState<CountryReportType[]>([]);

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const getCountryReportData = async ({
    election_schedule_id,
    time_range,
  }: {
    election_schedule_id: number | string;
    time_range?: string;
  }) => {
    setIsLoading(true);

    try {
      const response = await getCountryReport({
        election_schedule_id,
        time_range,
      });
      if (response?.data?.data) {
        const mappedArray = [];
        const mappedData = response?.data?.data;
        mappedData['percentage'] = `${mappedData?.percentage}%`;
        mappedArray.push(mappedData);
        setCountryReport(mappedArray);
        setIsLoading(false);
      } else {
        setIsLoading(false);
        setCountryReport([]);
        toast.error(t('DASHBOARD.DOWNLOAD_ERROR'));
      }
    } catch (err) {
      setIsLoading(false);
      setCountryReport([]);
      toast.error(t('DASHBOARD.DOWNLOAD_ERROR'));
    }
  };

  return {
    countryData,
    getCountryReportData,
    isLoading,
  };
};
